import { getConsentBehaviour, getHasBlocksWithoutEnforcedPermissions, getIsWixApp } from '../selectors/appRuntimeReader';
import { ShowConsentBehaviour } from '@wix/ambassador-devcenter-appsruntimereader-v1-app-runtime-data/types';
export const shouldShowConsent = (app, consentPermissions, isAppAlreadyInstalled) => {
  const consentBehaviour = getConsentBehaviour(app);
  const isWixApp = getIsWixApp(app);
  const isShowConsentFlag = consentBehaviour === ShowConsentBehaviour.SHOW_CONSENT;
  const isHideConsentFlag = consentBehaviour === ShowConsentBehaviour.SKIP_CONSENT;
  const shouldShowConsentForLegacyBlocks = (!isWixApp || isShowConsentFlag) && !isAppAlreadyInstalled && !isHideConsentFlag && getHasBlocksWithoutEnforcedPermissions(app);
  return consentPermissions.length > 0 || shouldShowConsentForLegacyBlocks;
};
//# sourceMappingURL=shouldShowConsent.js.map